module.exports = __webpack_public_path__ + "img/mtnz.d28e6d52.png";